import { ICategoriesWebServiceClient } from '@resources/resources';
import { CategorieDto } from '@resources/resources';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class GestionCategoriesResolver implements Resolve<Array<CategorieDto>> {

  constructor(private categorieWebService: ICategoriesWebServiceClient) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.categorieWebService.rechercheCategories();
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-categories/gestion.categories.resolver.ts